import { render, staticRenderFns } from "./save-confirmation-dialog.vue?vue&type=template&id=21175364"
import script from "./save-confirmation-dialog.vue?vue&type=script&lang=ts"
export * from "./save-confirmation-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports